import { Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  /** Overrides the generic "no rows" copy when the table knows why it is empty. */
  message?: string
  description?: string
  action?: ReactNode
}

const IMAGE_SIZE = { height: 160, width: 140 }
// With an action, the full-size image fills the grid theme's 300px overlay and leaves the action on its bottom edge.
const IMAGE_SIZE_WITH_ACTION = { height: 120, width: 105 }

// Defaulted so the component still satisfies the zero-argument TableEmptyState slot signature.
export const DefaultNoRowsState = ({ message, description, action }: Props = {}) => {
  const { t } = useTranslation('requests')
  const imageSize = action ? IMAGE_SIZE_WITH_ACTION : IMAGE_SIZE
  return (
    <Stack justifyContent="center" alignItems="center" gap={5} sx={{ mt: 0, height: '100%' }}>
      <Image src="/app/assets/table_empty_state.png" alt="welcome" height={imageSize.height} width={imageSize.width} />
      <Stack alignItems="center" gap={2}>
        <Typography variant="upsized-medium" color="text.default">
          {message ?? t('table.empty-row')}
        </Typography>
        {description && (
          <Typography variant="body-regular" color="text.muted">
            {description}
          </Typography>
        )}
      </Stack>
      {action}
    </Stack>
  )
}
